import React, { useEffect, useState } from "react";
import UserRaring from "./UserRating";
import { FormattedMessage } from "react-intl";
import { Comment, Form, Message } from "semantic-ui-react";
import styles from "./Comments.module.scss";
import { Body2, Heading2 } from "../value-cssmodules/TextComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  isAuthenticatedSelector,
  patternSelector,
  patternReviewSelector,
} from "../../utils/selectors";
import Spinner from "../Spinner";
import isEmpty from "../../validation/is-empty";
import CommentItem from "./CommentItem";
import CommentForm from "./CommentForm";
import PrimaryButton from "../Button/PrimaryButton";
import {
  createPatternReview,
  getPatternById,
} from "../../actions/patternActions";
import { useParams } from "react-router-dom";
import { CREATE_PATTERN_REVIEW_RESET } from "../../actions/constants/pattern";
import StarRating from "./UserRating/StarRating";

const Comments = () => {
  const { id } = useParams<{ id: string }>();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const { pattern, loading } = useSelector((state) => patternSelector(state));
  const { error: reviewError, success } = useSelector((state) =>
    patternReviewSelector(state)
  );
  const dispatch = useDispatch();
  const loggedIn = useSelector((state) => isAuthenticatedSelector(state));
  const sumbitHandler = (e: React.FormEvent) => {
    e.preventDefault();
    if (!id) return;
    dispatch(
      createPatternReview(id, {
        rating,
        comment,
      })
    );
  };

  useEffect(() => {
    if (success && id) {
      setRating(0);
      setComment("");
      dispatch({ type: CREATE_PATTERN_REVIEW_RESET });
      dispatch(getPatternById(id));
    }
  }, [dispatch, success, id]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      {pattern && !isEmpty(pattern.reviews) ? (
        <div className={styles.comments}>
          <Heading2>
            <FormattedMessage id={"nav.opinions"} defaultMessage={"Opinions"} />
          </Heading2>
          <UserRaring rating={pattern && pattern.rating} />
          <Body2>
            <FormattedMessage id={"nav.comments"} defaultMessage={"Comments"} />
          </Body2>
          <Comment.Group size="large">
            {pattern.reviews.map((review: any, i: number) => (
              <CommentItem key={review._id + i} review={review} />
            ))}
          </Comment.Group>
        </div>
      ) : (
        <Message info>
          {" "}
          <FormattedMessage id="site.reviews.noReviews" />
        </Message>
      )}
      {reviewError && <Message warning>{reviewError}</Message>}
      {success && (
        <Message success>
          <FormattedMessage id="site.reviews.reviewSubmitted" />
        </Message>
      )}
      {loggedIn ? (
        <>
          <h3 style={{ marginTop: '2rem', marginBottom: '1rem' }}>
            <FormattedMessage id="site.comments.leaveComment" defaultMessage="Leave a comment" />
          </h3>
          <Form onSubmit={sumbitHandler}>
            <Form.Group>
              <Form.Field width="4">
                <StarRating
                  rating={rating}
                  onRate={(e: any, val) => setRating(Number(val.rating || 0))}
                />
              </Form.Field>
              <Form.Field width="12">
                <CommentForm comment={comment} setComment={setComment} />
              </Form.Field>
            </Form.Group>
            <Form.Group width="8">
              <PrimaryButton>
                <FormattedMessage id="comments.submit" defaultMessage="Submit comment" />
              </PrimaryButton>
            </Form.Group>
          </Form>
        </>
      ) : (
        <Message warning>
          <FormattedMessage id="site.comments.notLoggedInComments" />
        </Message>
      )}
    </>
  );
};

export default Comments;
